// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"3cbee053","149":"e7e9473b","297":"0f1df30f","305":"f70b5385","413":"f36cf28f","453":"2218e1e4","536":"a13bebf4","560":"8184d312","585":"fd8e8576","595":"927be1a2","607":"a964ab23","665":"d931b26e","667":"d901a391","746":"33c15a75","837":"6956c9b8"}[chunkId] + ".chunk.js";
};